module.exports = __webpack_public_path__ + "/images/shop/error-notice/orange_car.jpg";